var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 34.875V58.5",
    stroke: "#18964E",
    strokeWidth: 6.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8599 69.39C94.8599 74.43 92.1599 79.1102 87.7949 81.6752L61.0649 97.1102C56.6999 99.6302 51.2998 99.6302 46.8898 97.1102L20.1598 81.6752C15.7948 79.1552 13.0947 74.475 13.0947 69.39V38.6102C13.0947 33.5702 15.7948 28.89 20.1598 26.325L46.8898 10.89C51.2548 8.37 56.6549 8.37 61.0649 10.89L87.7949 26.325C92.1599 28.89 94.8599 33.5252 94.8599 38.6102V69.39Z",
    stroke: "#18964E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72.9009V73.3509",
    stroke: "#18964E",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningGreen);
export default __webpack_public_path__ + "static/media/warning-green.8f3f0f291a4b5768754d73f36b925ba9.svg";
export { ForwardRef as ReactComponent };